import { useTranslation } from "@msuite/ui/localization";
import { Panels } from "@msuite/ui/panels";
import { SegmentedControl } from "@msuite/ui/segmented-control";
import { useState } from "react";
import { ProjectSettingsGeneral } from "./project-settings-general";
import type { ProjectSettingsTab } from "./shared";

/** Props Interface */
interface ProjectSettingsProps {
	projectId: string;
}

export function ProjectSettings({ projectId }: ProjectSettingsProps) {
	/** State */
	const [activeTab, setActiveTab] = useState<ProjectSettingsTab>("general");

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<SegmentedControl
					value={activeTab}
					orientation="vertical"
					onChange={setActiveTab}
					items={[
						{ value: "general", label: t("general.general"), cyId: "project-settings-general-tab" },
					]}
				/>
			</Panels.Panel>
			<Panels.Panel
				flex={3}
				className="bottom-space"
			>
				{activeTab === "general" && <ProjectSettingsGeneral projectId={projectId} />}
			</Panels.Panel>
		</Panels>
	);
}
